import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import Container from "../components/Container"
import SubHeader from "../components/SubHeader"
import P from "../components/P"

const HorizontalContainer = styled.div`
  min-width: 100vh;
  display: flex;
  justify-content: space-evenly;
`

const ContextSection = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "gatsby-astronaut.png" }) {
        childImageSharp {
          fixed(width: 300, height: 300) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      icon: file(relativePath: { eq: "gatsby-icon.png" }) {
        childImageSharp {
          fixed(width: 50, height: 50) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      flowchart: file(relativePath: { eq: "CSFC.jpg" }) {
        childImageSharp {
          fixed(width: 1031, height: 859, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)

  return (
    <>
      <Container noTop>
        <SubHeader>Context</SubHeader>
        <P>
          Each student receives a sample flow chart corresponding to their
          major. We tried to use that chart as an inspiration for our design as
          well as trying to be consistent with it since every student is
          familiar with such visual.
        </P>
      </Container>
      <HorizontalContainer>
        <Img fixed={data.flowchart.childImageSharp.fixed} />
      </HorizontalContainer>
    </>
  )
}

export default ContextSection
